import { GlobalDataConstants } from './globalData.constants'
import { IGlobalDataAction, IGlobalDataState } from './globalData.types'

export const initialGlobalDataState: IGlobalDataState = {
  isGlobalDataLoading: false,
}

export function globalDataReducer(
  state: IGlobalDataState = initialGlobalDataState,
  action: IGlobalDataAction
): IGlobalDataState {
  switch (action.type) {
    case GlobalDataConstants.IS_GLOBAL_DATA_LOADING:
      return { ...state, isGlobalDataLoading: action.isGlobalDataLoading }
    default:
      return state
  }
}
